var month2string = function (input) {
  var month = parseInt(input.toString().substr(4, 2)) - 1;
  var year = parseInt(input.toString().substr(0, 4));
  var dateObj = new Date(year, month);
  var language = bcp.settings.language === 'en' ? 'en-us' : language === 'pt' ? 'pt-br' : 'pt-br';
  var full_month = dateObj.toLocaleString(language, {month: 'long'});
  var full_year = dateObj.getFullYear();
  return full_month + '/' + full_year;
}

var ngAnalyticsLineGraph = function (Api) {
  return {
    restrict: 'A',
    scope: {
      label: '@'
    },
    link: function (scope, elements, attr) {
      if (scope.disabled) return false;
      scope.graphId = `graph-${(Math.random() * 100000).toFixed(0)}`;
      var buildGraph = function (month) {
        scope.full_month = month2string(month);
        var query = `analytics/histograms?month=${month}&axis=${attr.axis}`;

        if (attr.user !== undefined && attr.user !== '') {
          query += `&user_id=${attr.user}`;
        }
        if (attr.article !== undefined && attr.article !== '') {
          query += `&article_id=${attr.article}`;
        }
        if (attr.page !== undefined && attr.page !== '') {
          query += `&page_id=${attr.page}`;
        }

        setTimeout(function () {
          var render_graph = c3.generate({
            // bindto: elements[0].childNodes[2],
            bindto: '#' + scope.graphId,
            data: {
              x: 'date',
              columns: []
            },
            tooltip: {
              format: {
                name: function (name, ratio, id, index) {
                  return attr.label;
                }
              }
            },
            legend: {
              show: false
            },
            axis: {
              x: {
                type: 'timeseries',
                tick: {
                  format: '%d/%m'
                }
              }
            },
            size: {
              // width: 885
              // width: elements[0].clientWidth
            }
          });

          var renderRedraw;
          $('.tab-charts .tab').click(function () {
            if (renderRedraw) clearTimeout(renderRedraw);
            renderRedraw = setTimeout(function () {
              render_graph.flush();
            });
          });
          Api.get(query, function (err, ret) {
            if (err) return

            var total = 0;
            var x = ['date'], main = ['main'];
            for (var i = 0; i < ret.response.length; i++) {
              x.push(ret.response[i].date);
              main.push(ret.response[i].count);
              total += ret.response[i].count;
            }
            scope.total = total;

            var columns = [];
            columns.push(x);
            columns.push(main);

            render_graph.load({columns: columns});
          });
        })
      }
      if (attr.hasOwnProperty('article')) {
        attr.$observe('article', function (article) {
          if (attr.month && article && scope.$parent.project_data.plan.analytics_feature_enabled) buildGraph(attr.month);
        });
      } else if (attr.hasOwnProperty('page')) {
        attr.$observe('page', function (page) {
          if (attr.month && page && scope.$parent.project_data.plan.analytics_feature_enabled) buildGraph(attr.month);
        });
      }
      attr.$observe('month', function (month) {
        if (month &&
          scope.$parent.project_data.plan.analytics_feature_enabled &&
          !attr.hasOwnProperty('article') || attr.article
        ) buildGraph(month);
      });

    },
    templateUrl:'@@src/manager/shared/dir.analytics/line_graph.html'
  }
}
ngAnalyticsLineGraph.$inject = ['Api'];

var ngAnalyticsSingleCounter = function (Api) {
  return {
    restrict: 'A',
    scope: {
      label: '@'
    },
    link: function (scope, elements, attr) {
      var getCounter = function (month) {
        scope.full_month = month2string(month);
        var query = `analytics/counters?month=${month}&axis=${attr.axis}`;

        if (attr.user !== undefined && attr.user !== '') {
          query += `&user_id=${attr.user}`;
        }
        if (attr.article !== undefined && attr.article !== '') {
          query += `&article_id=${attr.article}`;
        }
        if (attr.page !== undefined && attr.page !== '') {
          query += `&page_id=${attr.page}`;
        }

        if (attr.course !== undefined && attr.course !== '' && attr.axis === 'users') {
          query = `course/${attr.course}/users?return_as=count&month=${month}&signup_pending=false&role=USR`;
        }
        if (attr.course !== undefined && attr.course !== '' && attr.axis === 'courses_annotations') {
          query = `course_annotation?return_as=count&course_id=${attr.course}&month=${month}`;
        }

        Api.get(query, function (err, ret) {
          if (!err) {
            if (ret.response && ret.response.data) {
              scope.counter = ret.response.data;
            } else {
              scope.counter = ret.response;
            }
          }
        });
      }
      if (attr.hasOwnProperty('article')) {
        attr.$observe('article', function (article) {
          if (attr.month && article && scope.$parent.project_data.plan.analytics_feature_enabled) getCounter(attr.month);
        });
      } else if (attr.hasOwnProperty('page')) {
        attr.$observe('page', function (page) {
          if (attr.month && page && scope.$parent.project_data.plan.analytics_feature_enabled) getCounter(attr.month);
        });
      }
      attr.$observe('month', function (month) {
        if (month &&
          scope.$parent.project_data.plan.analytics_feature_enabled &&
          !attr.hasOwnProperty('article') || attr.article
        ) getCounter(month);
      });
    },
    templateUrl:'@@src/manager/shared/dir.analytics/single_counter.html'
  }
}
ngAnalyticsSingleCounter.$inject = ['Api'];

var ngAnalyticsTrafficSource = function (Api, NgTableParams, $translate) {
  return {
    restrict: 'A',
    scope: true,
    link: function (scope, elements, attr) {
      if (scope.disabled) return false;

      var getTrafficSource = function (month) {
        scope.full_month = month2string(month);
        var query = `analytics/lists?month=${month}&axis=traffic_source`;

        if (attr.user !== undefined && attr.user !== '') {
          query += `&user_id=${attr.user}`;
        }
        if (attr.article !== undefined && attr.article !== '') {
          query += `&article_id=${attr.article}`;
        }
        if (attr.page !== undefined && attr.page !== '') {
          query += `&page_id=${attr.page}`;
        }

        Api.get(query, function (err, ret) {
          var traffic_source = [];

          var translate_traffic = {
            'organic': '',
            'mail': '',
            'reference': '',
            'direct': '',
            'display': '',
            'social': '',
            'push_notification': '',
            'social_paid': '',
            'other_ads': '',
            'afiliate': '',
            'search_paid': ''
          }
          $translate(['ANALYTICS.ORGANIC', 'ANALYTICS.MAIL', 'ANALYTICS.REFERENCE',
            'ANALYTICS.DIRECT', 'ANALYTICS.DISPLAY', 'ANALYTICS.SOCIAL', 'ANALYTICS.PUSH_NOTIFICATION', 'ANALYTICS.SOCIAL_PAID',
            'ANALYTICS.OTHER_ADS', 'ANALYTICS.AFILIATE', 'ANALYTICS.SEARCH_PAID']).then(function (translations) {
            translate_traffic['organic'] = translations['ANALYTICS.ORGANIC'];
            translate_traffic['mail'] = translations['ANALYTICS.MAIL'];
            translate_traffic['reference'] = translations['ANALYTICS.REFERENCE'];
            translate_traffic['direct'] = translations['ANALYTICS.DIRECT'];
            translate_traffic['display'] = translations['ANALYTICS.DISPLAY'];
            translate_traffic['social'] = translations['ANALYTICS.SOCIAL'];
            translate_traffic['push_notification'] = translations['ANALYTICS.PUSH_NOTIFICATION'];
            translate_traffic['social_paid'] = translations['ANALYTICS.SOCIAL_PAID'];
            translate_traffic['other_ads'] = translations['ANALYTICS.OTHER_ADS'];
            translate_traffic['afiliate'] = translations['ANALYTICS.AFILIATE'];
            translate_traffic['search_paid'] = translations['ANALYTICS.SEARCH_PAID'];

            for (var data in ret.response) {
              if (ret.response[data].visits && ret.response[data].visits > 0) {
                traffic_source.push({
                  title: translate_traffic[data],
                  reads: ret.response[data].reads,
                  visits: ret.response[data].visits
                });
              }
            }
            if (traffic_source.length > 0) scope.traffic_source = new NgTableParams({sorting: {'visits': 'desc'}}, {counts: [], dataset: traffic_source});
          });
        });
      }
      if (attr.hasOwnProperty('article')) {
        attr.$observe('article', function (article) {
          if (attr.month && article && scope.$parent.project_data.plan.analytics_feature_enabled) getTrafficSource(attr.month);
        });
      }
      attr.$observe('month', function (month) {
        if (month &&
          scope.$parent.project_data.plan.analytics_feature_enabled &&
          !attr.hasOwnProperty('article') || attr.article
        ) getTrafficSource(month);
      });
    },
    templateUrl:'@@src/manager/shared/dir.analytics/traffic_source.html'
  }
}
ngAnalyticsTrafficSource.$inject = ['Api', 'NgTableParams', '$translate'];

var ngAnalyticsList = function (Api, NgTableParams) {
  return {
    restrict: 'A',
    scope: {
      label: '@'
    },
    link: function (scope, elements, attr) {
      if (scope.disabled) return false;

      scope.image_path = scope.$parent.image_path;
      scope.user_path = scope.$parent.user_path;
      scope.list = false;
      var getList = function (month) {
        scope.full_month = month2string(month);
        var query = `analytics/lists?month=${month}&axis=${attr.axis}`;

        if (attr.user !== undefined && attr.user !== '') {
          query += `&user_id=${attr.user}`;
        }
        if (attr.article !== undefined && attr.article !== '') {
          query += `&article_id=${attr.article}`;
        }
        if (attr.page !== undefined && attr.page !== '') {
          query += `&page_id=${attr.page}`;
        }

        Api.get(query, function (err, ret) {
          if (!err && ret.response.length > 0) scope.list = new NgTableParams({sorting: {'sessions': 'desc'}}, {counts: [], dataset: ret.response});
          else scope.list = false;
        });
      }
      if (attr.hasOwnProperty('article')) {
        attr.$observe('article', function (article) {
          if (attr.month && article && scope.$parent.project_data.plan.analytics_feature_enabled) getList(attr.month);
        });
      }
      attr.$observe('month', function (month) {
        if (month &&
          scope.$parent.project_data.plan.analytics_feature_enabled &&
          !attr.hasOwnProperty('article') || attr.article
        ) getList(month);
      });
    },
    templateUrl: function (elements, attr) {
      var axis = {
        top_landing_posts: '@@src/manager/shared/dir.analytics/list_post.html',
        top_posts: '@@src/manager/shared/dir.analytics/list_post.html',
        top_authors: '@@src/manager/shared/dir.analytics/list_user.html',
        top_users: '@@src/manager/shared/dir.analytics/list_user.html',
        top_groups: '@@src/manager/shared/dir.analytics/list_group.html'
      }
      return axis[attr.axis]
    }
  }
}
ngAnalyticsList.$inject = ['Api', 'NgTableParams'];

var ngAnalyticsLinesCounter = function (Api) {
  return {
    restrict: 'A',
    scope: {
      label_1st: '@label1st',
      label_2nd: '@label2nd'
    },
    link: function (scope, elements, attr) {
      if (scope.disabled) return false;

      var getCounter = function (line) {
        var query = `analytics/counters?axis=${attr[`axis${line}`]}`;

        if (attr.user !== undefined && attr.user !== '') {
          query += `&user_id=${attr.user}`;
        }
        if (attr.article !== undefined && attr.article !== '') {
          query += `&article_id=${attr.article}`;
        }
        if (attr.page !== undefined && attr.page !== '') {
          query += `&page_id=${attr.page}`;
        }
        if (attr.course !== undefined && attr.course !== '' && attr[`axis${line}`] === 'users') {
          query = `course/${attr.course}/users/?return_as=count&signup_pending=false&role=USR`;
        }
        if (attr.course !== undefined && attr.course !== '' && attr[`axis${line}`] === 'courses_classes') {
          query = `course_class?return_as=count&status=1&course_id=${attr.course}`;
        }
        scope.loadingCounter = true;

        Api.get(query, function (err, ret) {
          scope[`label_${line}`] = attr[`label${line}`];
          if (!err) {
            if (ret.response && ret.response.data) {
              scope[`counter_${line}`] = ret.response.data;
            } else {
              scope[`counter_${line}`] = ret.response;
            }
          }
          scope.loadingCounter = false;
        });
      }
      scope.icon = attr.icon || '';
      scope.size = attr.size || 's';
      if (attr.hasOwnProperty('article')) {
        attr.$observe('article', function (article) {
          if (article && 'axis1st' in attr && scope.$parent.project_data.plan.analytics_feature_enabled) getCounter('1st');
          if (article && 'axis2nd' in attr && scope.$parent.project_data.plan.analytics_feature_enabled) getCounter('2nd');
        });
      } else if (attr.hasOwnProperty('page')) {
        attr.$observe('page', function (page) {
          if (page && 'axis1st' in attr && scope.$parent.project_data.plan.analytics_feature_enabled) getCounter('1st');
          if (page && 'axis2nd' in attr && scope.$parent.project_data.plan.analytics_feature_enabled) getCounter('2nd');
        });
      } else {
        if ('axis1st' in attr) getCounter('1st');
        if ('axis2nd' in attr) getCounter('2nd');
      }
    },
    templateUrl:'@@src/manager/shared/dir.analytics/lines_counter.html'
  }
}
ngAnalyticsLinesCounter.$inject = ['Api'];

var ngNpsCourse = function (Api) {
  return {
    restrict: 'A',
    scope: {
      course: '@course',
      type: '@type',
      label_1st: '@label1st'
    },
    link: function (scope, elements, attr) {
      if (scope.disabled) return false;

      var query = `user_experience_review/net_promoter_score/course/${scope.course}`;
      scope.loadingCounter = true;
      Api.get(query, function (err, ret) {
        if (!err) {
          if (scope.type === 'platform_nps') {
            scope[`counter_1st`] = ret.response.data.platform_nps === null ? null : Math.round(ret.response.data.platform_nps.nps);
          } else {
            scope[`counter_1st`] = ret.response.data.class_nps === null ? null : Math.round(ret.response.data.class_nps.nps);
          }
        }
        scope.loadingCounter = false;
      });
      scope.icon = attr.icon || '';
      scope.size = attr.size || 's';
    },
    templateUrl:'@@src/manager/shared/dir.analytics/lines_counter.html'
  }
}
ngNpsCourse.$inject = ['Api'];

angular.module('app.full')
  .directive('ngAnalyticsLineGraph', ngAnalyticsLineGraph)
  .directive('ngAnalyticsSingleCounter', ngAnalyticsSingleCounter)
  .directive('ngAnalyticsLinesCounter', ngAnalyticsLinesCounter)
  .directive('ngAnalyticsTrafficSource', ngAnalyticsTrafficSource)
  .directive('ngAnalyticsList', ngAnalyticsList)
  .directive('ngNpsCourse', ngNpsCourse);
